module.exports = __webpack_public_path__ + "img/ipo-team-icon@3x.ddf2cbb7.png";